export const NETWORK = {
  LOCAL: "local",
  SB: "sb",
  RC: "rc",
  STAGE: "stage",
  LIVE: "live",
};

export const LANGUAGE = document.querySelector("html")?.lang || "ko";
export const COUNTRY = document.querySelector("html")?.dataset?.country || "KR";

export const STATIC_DOMAIN = {
  [NETWORK.LOCAL]: "https://op-assets.ncsoft.com",
  [NETWORK.SB]: "https://assets.sb.plaync.com",
  [NETWORK.RC]: "https://rc-assets.playnccdn.com",
  [NETWORK.STAGE]: "https://stage-assets.playnccdn.com",
  [NETWORK.LIVE]: "https://assets.playnccdn.com",
};

export const PLAYNC_DOMAIN = {
  [NETWORK.LOCAL]: "https://www.sb.plaync.com",
  [NETWORK.SB]: "https://www.sb.plaync.com",
  [NETWORK.RC]: "https://rc-www.plaync.com",
  [NETWORK.STAGE]: "https://www.plaync.com",
  [NETWORK.LIVE]: "https://www.plaync.com",
};

export const LOGIN_DOMAIN = {
  [NETWORK.LOCAL]: "https://login.sb.plaync.com",
  [NETWORK.SB]: "https://login.sb.plaync.com",
  [NETWORK.RC]: "https://rc-login.plaync.com",
  [NETWORK.STAGE]: "https://login.plaync.com",
  [NETWORK.LIVE]: "https://login.plaync.com",
};

export const LOGIN_API_DOMAIN = {
  [NETWORK.LOCAL]: "https://loginapi.sb.plaync.com",
  [NETWORK.SB]: "https://loginapi.sb.plaync.com",
  [NETWORK.RC]: "https://rc-loginapi.plaync.com",
  [NETWORK.STAGE]: "https://loginapi.plaync.com",
  [NETWORK.LIVE]: "https://loginapi.plaync.com",
};

export const CERT_DOMAIN = {
  [NETWORK.LOCAL]: "https://cert.sb.plaync.com",
  [NETWORK.SB]: "https://cert.sb.plaync.com",
  [NETWORK.RC]: "https://rc-cert.plaync.com",
  [NETWORK.STAGE]: "https://loginapi.plaync.com",
  [NETWORK.LIVE]: "https://cert.plaync.com",
};

export const ID_DOMAIN = {
  [NETWORK.LOCAL]: "https://id.sb.plaync.com",
  [NETWORK.SB]: "https://id.sb.plaync.com",
  [NETWORK.RC]: "https://rc-id.plaync.com",
  [NETWORK.STAGE]: "https://id.plaync.com",
  [NETWORK.LIVE]: "https://id.plaync.com",
};
